{
  "welcome.title": "Jūsų vaikas turi tiek daug ką pasakyti",
  "welcome.body": "Atsakykite į kelis trumpus klausimus ir Timo sudarys nemokamą, jūsų vaikui pritaikytą planą, kuris padės jam atrasti savo balsą. Užtruks apie 90 sekundžių.",
  "welcome.cta": "Pradėti",
  "gender.question": "Jūsų vaikas berniukas ar mergaitė?",
  "gender.opt.boy": "Berniukas",
  "gender.opt.girl": "Mergaitė",
  "age.question": "Kiek metų jūsų vaikui?",
  "age.sub": "Kad Timo klaustų to, kas tinka jo amžiui.",
  "age.opt.under3": "Iki 3",
  "age.opt.3-4": "3-4",
  "age.opt.5-6": "5-6",
  "age.opt.7+": "7+",
  "name.question": "Kuo vardu jūsų vaikas?",
  "name.sub": "Arba vardas, kuriuo vadinate namuose. Taip Timo kalbės asmeniškiau.",
  "name.placeholder": "Vaiko vardas",
  "words.question": "Kiek maždaug žodžių gali pasakyti {name}?",
  "words.sub": "Užtenka apytikslio spėjimo.",
  "words.opt.0": "0 žodžių",
  "words.opt.1-5": "1-5 žodžių",
  "words.opt.6-10": "6-10 žodžių",
  "words.opt.11-50": "11-50 žodžių",
  "words.opt.50+": "50+ žodžių",
  "words.opt.unsure": "Nežinau",
  "sentences.question": "Ar {name} kalba ilgesniais sakiniais (4-6 žodžiai) ir gramatika būna beveik taisyklinga?",
  "sentences.opt.yes": "Taip",
  "sentences.opt.no": "Ne",
  "delay_fact.title": "Kuo anksčiau pradėsite, tuo didesnis pokytis",
  "delay_fact.body": "Kelios minutės per dieną su Timo, ir {name} jų laukia.",
  "delay_fact.cta": "Toliau",
  "calc.title": "Ruošiame apžvalgą, kaip bendrauja {name}",
  "calc.arr.0": "Suprantame, ko reikia jūsų vaikui...",
  "calc.arr.1": "Lyginame su amžiaus etapais...",
  "calc.arr.2": "Parenkame tinkamas veiklas...",
  "calc.arr.3": "Beveik baigta...",
  "calc.review.text": "Mano sūnus nuo kelių žodžių perėjo prie trumpų sakinių. Su Timo jam pačiam norisi kalbėti.",
  "calc.review.author": "Rasa, 4 metų vaiko mama",
  "score.title": "Kaip bendrauja {name}",
  "score.arr.0": "Kalbėjimas",
  "score.arr.1": "Supratimas",
  "score.arr.2": "Pokalbis",
  "score.arr.3": "Pasitikėjimas",
  "score.arr.4": "Bendravimas",
  "score.cta": "Sudaryti planą",
  "voice.question": "Pasirinkite Timo balsą",
  "voice.sub": "Palieskite kortelę ir išgirsite pavyzdį.",
  "email.title": "Susikurkite nemokamą paskyrą",
  "email.sub": "Planas išsisaugos ir galėsite bet kada vėl prisijungti.",
  "conversation.question": "Ar {name} gali palaikyti pokalbį be didelės suaugusiojo pagalbos?",
  "conversation.opt.yes": "Taip",
  "conversation.opt.no": "Ne",
  "questions.question": "Ar {name} mėgsta daug klausinėti, pavyzdžiui, „Kodėl lyja?“",
  "questions.opt.yes": "Taip",
  "questions.opt.no": "Ne",
  "find_words.question": "Ar {name} kartais niekaip neranda reikiamo žodžio?",
  "find_words.opt.yes": "Taip",
  "find_words.opt.no": "Ne",
  "sounds.question": "Kuriuos garsus {name} taria aiškiai?",
  "sounds.sub": "Pažymėkite visus tinkamus. Taip Timo parinks tinkamas užduotis.",
  "sounds.opt.p_b": "P, B  (puodas, batas)",
  "sounds.opt.m_n": "M, N  (mama, namas)",
  "sounds.opt.t_d": "T, D  (tortas, dantis)",
  "sounds.opt.k_g": "K, G  (katė, gėlė)",
  "sounds.opt.f_v": "F, V  (fėja, vanduo)",
  "sounds.opt.s_z": "S, Z  (saulė, zebras)",
  "sounds.opt.l": "L  (liūtas)",
  "sounds.opt.r": "R  (ratas)",
  "sounds.opt.sh_ch": "Š, Č  (šuo, čiuožykla)",
  "therapist.question": "Ar {name} kada nors lankėsi pas logopedą?",
  "therapist.opt.yes": "Taip",
  "therapist.opt.no": "Ne",
  "diagnosis.question": "Ar vaikui nustatyta kokia nors diagnozė?",
  "diagnosis.sub": "Tai lieka privatu ir tik padeda Timo pritaikyti planą.",
  "diagnosis.opt.autism": "Autizmas / ASS",
  "diagnosis.opt.speech_delay": "Kalbos raidos atsilikimas",
  "diagnosis.opt.adhd": "ADHD",
  "diagnosis.opt.none": "Nėra diagnozės",
  "diagnosis.opt.prefer_not": "Nenoriu sakyti",
  "social.question": "Ar {name} sunkiai jaučiasi grupėje ar tarp kitų vaikų?",
  "social.opt.yes": "Taip",
  "social.opt.no": "Ne",
  "goals.question": "Kuo Timo galėtų padėti labiausiai?",
  "goals.sub": "Pasirinkite iki 3. Tai nulems visą planą.",
  "goals.opt.confidence": "Įgyti drąsos kalbėti",
  "goals.opt.conversations": "Mokytis kasdienių pokalbių",
  "goals.opt.social": "Susitvarkyti su sudėtingomis situacijomis",
  "goals.opt.feelings": "Sveikai išreikšti jausmus",
  "goals.opt.calm": "Nurimti, kai užplūsta jausmai",
  "goals.opt.school": "Pasiruošti mokyklai",
  "topics.question": "Pasirinkite mėgstamiausias temas",
  "topics.sub": "Timo įpins jas į užduotis.",
  "topics.opt.animals": "Gyvūnai",
  "topics.opt.space": "Kosmosas",
  "topics.opt.vehicles": "Transportas",
  "topics.opt.music": "Muzika",
  "topics.opt.nature": "Gamta",
  "topics.opt.food": "Maistas",
  "experts.title": "Kurta su specialistais, pritaikyta jūsų vaikui",
  "experts.body": "Timo Helps remiasi kalbos ir autizmo bendravimo metodika, o tada prisitaiko prie jūsų atsakymų. Niekada ne visiems vienodai.",
  "experts.quote.text": "Daugiau nei 10 000 šeimų naudoja Timo Helps, kad jų vaikas atrastų savo balsą.",
  "experts.quote.author": "4,8 vidutinis įvertinimas",
  "experts.cta": "Žiūrėti planą",
  "learn_style.question": "Kaip {name} mieliausiai mokosi?",
  "learn_style.opt.hands_on": "Darant ką nors rankomis",
  "learn_style.opt.stories": "Klausantis istorijų",
  "learn_style.opt.video": "Žiūrint vaizdo įrašus",
  "learn_style.opt.games": "Žaidžiant",
  "strengths.question": "Kokios vaiko stiprybės?",
  "strengths.sub": "Pažymėkite visas, kurios tinka.",
  "strengths.opt.creative": "Kūrybingumas",
  "strengths.opt.curious": "Smalsumas",
  "strengths.opt.caring": "Rūpestingumas",
  "strengths.opt.determined": "Užsispyrimas",
  "strengths.opt.funny": "Humoras",
  "challenge.question": "Kas vaikui dabar sunkiausia?",
  "challenge.opt.frustrated": "Greitai nusivilia",
  "challenge.opt.distracted": "Lengvai išsiblaško",
  "challenge.opt.shy": "Drovisi ar nerimauja tarp žmonių",
  "challenge.opt.overwhelmed": "Viskas greitai tampa per daug",
  "daily_time.question": "Kiek laiko per dieną realu skirti?",
  "daily_time.sub": "Net kelios minutės greitai susideda.",
  "daily_time.opt.5": "Mažas postūmis",
  "daily_time.hint.5": "5 min. per dieną",
  "daily_time.opt.10": "Kaip tik",
  "daily_time.hint.10": "10 min. per dieną",
  "daily_time.opt.20": "Pilnu tempu",
  "daily_time.hint.20": "20 min. per dieną",
  "when.question": "Kada {name} mokysis?",
  "when.opt.morning": "Rytas",
  "when.hint.morning": "Rami pradžia",
  "when.opt.afternoon": "Diena",
  "when.hint.afternoon": "Įkrova vidury dienos",
  "when.opt.evening": "Vakaras",
  "when.hint.evening": "Nurimti prieš miegą",
  "who_uses.question": "Kas naudos Timo Helps kartu su vaiku?",
  "who_uses.opt.mom": "Mama",
  "who_uses.opt.dad": "Tėtis",
  "who_uses.opt.grandparent": "Senelis ar močiutė",
  "who_uses.opt.specialist": "Specialistas ar mokytojas",
  "who_uses.opt.themselves": "Vaikas pats",
  "timeline.question": "Kaip greitai norite pamatyti pokytį?",
  "timeline.opt.weeks": "Per kelias savaites",
  "timeline.opt.1-2m": "Per 1-2 mėnesius",
  "timeline.opt.no_rush": "Neskubu",
  "main_goal.question": "Koks dabar jūsų svarbiausias tikslas?",
  "main_goal.opt.catch_up": "Padėti vaikui pasivyti",
  "main_goal.opt.on_track": "Išlaikyti pažangą",
  "main_goal.opt.confidence": "Stiprinti pasitikėjimą savimi",
  "main_goal.opt.other": "Kažkas kita",
  "profile_done.title": "Visas planas paruoštas",
  "profile_done.body": "Timo turi viską, ko reikia. Pradėkime mokytis kartu.",
  "profile_done.cta": "Pradėti"
}
